//#region src/entry/core/rolex-clock.ts
function e() {
	(function() {
		let e = document.createElement("script");
		e.src = "https://static.rolex.com/retailers/clock/retailercall.js", e.async = !0, e.defer = !0, e.onload = function() {
			new RolexRetailerClock().getRetailerClock({
				dealerAPIKey: "7690d64ca1cf2da480f8390ed83140f3",
				lang: "en-us",
				colour: "gold"
			});
		}, document.body.appendChild(e);
	})(), (function() {
		new MutationObserver((e) => {
			for (let t of e) {
				let e = t.target;
				if (e.id === "header-drawer") {
					let t = e.querySelector(".rolex-retailer-clock");
					t && (new RolexRetailerClock().getRetailerClock({
						dealerAPIKey: "7690d64ca1cf2da480f8390ed83140f3",
						lang: "en-us",
						colour: "gold"
					}), t.dataset.loaded = "true");
				}
			}
		}).observe(document.body, {
			childList: !0,
			subtree: !0
		});
	})();
	let e = document.querySelector("div[data-header-col-1]");
	e && e.classList.remove("invisible");
}
document.addEventListener("DOMContentLoaded", () => {
	e();
});
//#endregion
